/** @file Euclidean distance from a point to a segment (both in the same 2D space). */
import { clamp } from '@pose2d/math/clamp';
import { trig } from '@pose2d/math/trig';

/** Distance from (px, py) to the segment (ax, ay)-(bx, by); a zero-length segment is its single point. */
export function pointSegmentDistance(px: number, py: number, ax: number, ay: number, bx: number, by: number): number {
  const ex = bx - ax;
  const ey = by - ay;
  const len2 = ex * ex + ey * ey;
  const t = len2 > 0 ? clamp(((px - ax) * ex + (py - ay) * ey) / len2, 0, 1) : 0;
  return trig.hypot(px - (ax + t * ex), py - (ay + t * ey));
}
